var _path, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatDisabledIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.39579 20.0237L7.10803 19.8582L6.79208 19.96L2.79108 21.2484C2.77981 21.252 2.76755 21.2491 2.75921 21.2408C2.7509 21.2325 2.74799 21.2202 2.75155 21.2092L2.75159 21.2091L4.04004 17.2079L4.14178 16.892L3.97634 16.6042C3.17325 15.2074 2.75 13.6232 2.75 12C2.75 6.88675 6.88744 2.75 12 2.75C17.1132 2.75 21.25 6.88744 21.25 12C21.25 17.1132 17.1126 21.25 12 21.25C10.3768 21.25 8.79264 20.8268 7.39579 20.0237ZM2.03773 20.9792L2.03774 20.9792L2.03773 20.9792Z",
    stroke: "#B5B5B5",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 1,
    fill: "#B5B5B5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1,
    fill: "#B5B5B5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 1,
    fill: "#B5B5B5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatDisabledIcon);
export default __webpack_public_path__ + "static/media/chat-disabled-icon.448076dba8dcbf8c4bb122cf07fcce98.svg";
export { ForwardRef as ReactComponent };